import { KeyCode } from '../../enums/key_code';

app.MenuItemTabView = app.TabView.extend({
  isSingleListTab: true,
  supportsElementRouting: true,

  _bindHotkeys() {
    this.addKeyboardListener(KeyCode.KeyN, () => {
      this.menuItemListView.createNew();
    });
  },

  initialize(options) {
    app.TabView.prototype.initialize.apply(this, arguments);

    this.menuItemListView = new app.MenuItemListView({
      collection: this.collection,
      detailsView: app.MenuItemDetailsView,
      canCreate: options.canCreate,
      cellView: app.MenuItemCellView,
      tabView: this,
      useVList: true,
      isReadOnly: this.isReadOnly,
      updateUrlWithSelectedModel: (_menuItemId) => {
        return true;
      },
    });
    this.setLeftView(this.menuItemListView);

    this._bindHotkeys();
  },

  setSelectedElementId(itemId) {
    this.menuItemListView.setSelectedItemId(itemId);
  },
});
